import { AmazonIcon, WalmartCircleIcon } from '@vizit/icons';
import type { ComponentType } from 'react';

/**
 * Maps RetailerConfig.baseIcon string values to the actual icon components.
 * Add new entries here when a new retailer is added to RETAILER_CONFIG_MAP.
 */
export const RETAILER_ICONS: Record<string, ComponentType<{ size?: number }>> = {
  AmazonIcon,
  WalmartCircleIcon,
};
